export const {REACT_APP_API_BASE_URL, REACT_APP_X_API_KEY} = process.env;